import { Copy, Flex } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export interface AccordionRuleHeaderProps {
  showSubheader: boolean;
  header: string;
  subheader: string;
}

export function AccordionRuleHeader({
  showSubheader,
  header,
  subheader,
}: AccordionRuleHeaderProps): JSX.Element {
  return (
    <Flex flexDirection="column">
      <Copy variant="body" color="primaryText">
        {header}
      </Copy>
      {showSubheader && (
        <Copy variant="body" color="secondaryText">
          {subheader}
        </Copy>
      )}
    </Flex>
  );
}
